import React from "react";

const Overview = () => {
  return (
    <>
      <div className="tab-content-section">
        <div className="row g-4">
          <div className="col-md-3 d-flex text-center">
            <div className="p-4 border rounded w-100 h-100 d-flex flex-column justify-content-center">
              <img
                src="../assets/images/users/avatar-1.jpg"
                className="rounded-circle mb-3"
                width="120"
              />
              <h5>Financial Adda ®</h5>
              <p className="text-muted">Stock Market | Mutual Funds | IPO</p>
              <span className="badge bg-danger">Finance</span>
            </div>
          </div>

          <div className="col-md-9">
            <div className="row g-4">
              <div className="col-md-3 d-flex">
                <div className="p-4 border rounded text-center w-100 h-100 d-flex flex-column justify-content-center">
                  <h3 className="text-success">236.06K</h3>
                  <p className="mb-0">Followers</p>
                </div>
              </div>

              <div className="col-md-3 d-flex">
                <div className="p-4 border rounded text-center w-100 h-100 d-flex flex-column justify-content-center">
                  <h3 className="text-success">192</h3>
                  <p className="mb-0">Average Likes</p>
                </div>
              </div>

              <div className="col-md-3 d-flex">
                <div className="p-4 border rounded text-center w-100 h-100 d-flex flex-column justify-content-center">
                  <h3 className="text-warning">6</h3>
                  <p className="mb-0">Average Comments</p>
                </div>
              </div>

              <div className="col-md-3 d-flex">
                <div className="p-4 border rounded text-center text-white w-100 h-100 d-flex flex-column justify-content-center">
                  <h3>0.08%</h3>
                  <p className="mb-0">Engagement Rate</p>
                </div>
              </div>

              <div className="col-md-3 d-flex">
                <div className="p-4 border rounded text-center w-100 h-100 d-flex flex-column justify-content-center">
                  <h3 className="text-warning">10.98K</h3>
                  <p className="mb-0">Avg Reel Views</p>
                </div>
              </div>

              <div className="col-md-3 d-flex">
                <div className="p-4 border rounded text-center w-100 h-100 d-flex flex-column justify-content-center">
                  <h3 className="text-success">216.92</h3>
                  <p className="mb-0">Avg Reel Likes</p>
                </div>
              </div>

              <div className="col-md-3 d-flex">
                <div className="p-4 border rounded text-center w-100 h-100 d-flex flex-column justify-content-center">
                  <h3 className="text-warning">11.67</h3>
                  <p className="mb-0">Avg Reel Comments</p>
                </div>
              </div>

              <div className="col-md-3 d-flex">
                <div className="p-4 border rounded text-center w-100 h-100 d-flex flex-column justify-content-center">
                  <h3 className="text-warning">4.1K</h3>
                  <p className="mb-0">Posts Count</p>
                </div>
              </div>

              <div className="col-md-4 d-flex">
                <div className="p-4 border rounded text-center w-100 h-100 d-flex flex-column justify-content-center">
                  <h3 className="text-danger">41.99%</h3>
                  <p className="mb-0">Hidden Likes</p>
                </div>
              </div>

              <div className="col-md-4 d-flex">
                <div className="p-4 border rounded text-center w-100 h-100 d-flex flex-column justify-content-center">
                  <h3>🇮🇳 India</h3>
                  <p className="mb-0">Location</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 mt-4">
          <div className="p-4 border rounded">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Audience Growth</h5>
              <select className="form-select w-auto">
                <option>Last 6 Months</option>
              </select>
            </div>
            <div className="d-flex gap-4 mb-3" id="growthTabs">
              <span
                className="fw-semibold text-danger border-bottom border-danger pb-1"
                data-type="all"
              >
                ALL
              </span>
              <span className="fw-semibold text-muted" data-type="followers">
                FOLLOWERS
              </span>
              <span className="fw-semibold text-muted" data-type="following">
                FOLLOWING
              </span>
            </div>
            <div id="audienceChart" style={{ height: "300px" }}></div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-md-6">
            <div className="p-4 border rounded">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Influencers Lookalikes</h5>
                <a href="#">
                  <i className="ri-question-line text-muted"></i>
                </a>
              </div>

              <a
                href="#"
                className="d-flex align-items-center mb-3 text-decoration-none text-dark"
              >
                <img
                  src="../assets/images/users/avatar-2.jpg"
                  className="rounded-circle me-3"
                  width="50"
                />
                <div>
                  <h6 className="mb-0">Shreya Thakur</h6>
                  <small className="text-muted">
                    46.56K followers, 205 engagements
                  </small>
                </div>
              </a>

              <a
                href="#"
                className="d-flex align-items-center mb-3 text-decoration-none text-dark"
              >
                <img
                  src="../assets/images/users/avatar-3.jpg"
                  className="rounded-circle me-3"
                  width="50"
                />
                <div>
                  <h6 className="mb-0">ET Money</h6>
                  <small className="text-muted">
                    518.08K followers, 356 engagements
                  </small>
                </div>
              </a>

              <a
                href="#"
                className="d-flex align-items-center mb-3 text-decoration-none text-dark"
              >
                <img
                  src="../assets/images/users/avatar-4.jpg"
                  className="rounded-circle me-3"
                  width="50"
                />
                <div>
                  <h6 className="mb-0">Ketan Mali</h6>
                  <small className="text-muted">
                    540.61K followers, 1.49K engagements
                  </small>
                </div>
              </a>

              <a href="#" className="text-end text-danger fw-semibold d-block">
                VIEW MORE
              </a>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Audience Lookalikes</h5>
                <a href="#">
                  <i className="ri-question-line text-muted"></i>
                </a>
              </div>

              <a
                href="#"
                className="d-flex align-items-center mb-3 text-decoration-none text-dark"
              >
                <img
                  src="../assets/images/users/avatar-5.jpg"
                  className="rounded-circle me-3"
                  width="50"
                />
                <div>
                  <h6 className="mb-0">Ankur (MBA) and Parth (CA)</h6>
                  <small className="text-muted">
                    348.14K followers, 210 engagements
                  </small>
                </div>
              </a>

              <a
                href="#"
                className="d-flex align-items-center mb-3 text-decoration-none text-dark"
              >
                <img
                  src="../assets/images/users/avatar-6.jpg"
                  className="rounded-circle me-3"
                  width="50"
                />
                <div>
                  <h6 className="mb-0">Finventure | Stock market</h6>
                  <small className="text-muted">
                    395.01K followers, 555 engagements
                  </small>
                </div>
              </a>

              <a
                href="#"
                className="d-flex align-items-center mb-3 text-decoration-none text-dark"
              >
                <img
                  src="../assets/images/users/avatar-7.jpg"
                  className="rounded-circle me-3"
                  width="50"
                />
                <div>
                  <h6 className="mb-0">Stock Market Info Mania</h6>
                  <small className="text-muted">
                    574.04K followers, 807 engagements
                  </small>
                </div>
              </a>

              <a href="#" className="text-end text-danger fw-semibold d-block">
                VIEW MORE
              </a>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-md-6">
            <div className="p-4 border rounded">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Influencer Brand Affinity</h5>
                <a href="#">
                  <i className="ri-question-line text-muted"></i>
                </a>
              </div>

              <a
                href="#"
                className="d-flex align-items-center mb-3 text-decoration-none text-dark"
              >
                <img
                  src="../assets/images/brands/airtel.png"
                  className="me-3"
                  width="40"
                />
                <h6 className="mb-0">Airtel</h6>
              </a>

              <a
                href="#"
                className="d-flex align-items-center mb-3 text-decoration-none text-dark"
              >
                <img
                  src="../assets/images/brands/bosch.png"
                  className="me-3"
                  width="40"
                />
                <h6 className="mb-0">Bosch</h6>
              </a>

              <a
                href="#"
                className="d-flex align-items-center mb-3 text-decoration-none text-dark"
              >
                <img
                  src="../assets/images/brands/honeywell.png"
                  className="me-3"
                  width="40"
                />
                <h6 className="mb-0">Honeywell</h6>
              </a>

              <a
                href="#"
                className="d-flex align-items-center mb-3 text-decoration-none text-dark"
              >
                <img
                  src="../assets/images/brands/hyundai.png"
                  className="me-3"
                  width="40"
                />
                <h6 className="mb-0">Hyundai</h6>
              </a>

              <a href="#" className="text-end text-danger fw-semibold d-block">
                VIEW MORE
              </a>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Influencer Interests</h5>
                <a href="#">
                  <i className="ri-question-line text-muted"></i>
                </a>
              </div>

              <div className="d-flex flex-wrap gap-2">
                <a
                  href="#"
                  className="badge bg-light text-dark border px-3 py-2"
                >
                  📺 Television & Film
                </a>
                <a
                  href="#"
                  className="badge bg-light text-dark border px-3 py-2"
                >
                  🛍 Shopping & Retail
                </a>
                <a
                  href="#"
                  className="badge bg-light text-dark border px-3 py-2"
                >
                  💻 Electronics & Computers
                </a>
                <a
                  href="#"
                  className="badge bg-light text-dark border px-3 py-2"
                >
                  💼 Business & Careers
                </a>
                <a
                  href="#"
                  className="badge bg-light text-dark border px-3 py-2"
                >
                  🏠 Home Decor, Furniture & Garden
                </a>
                <a
                  href="#"
                  className="badge bg-light text-dark border px-3 py-2"
                >
                  🏍 Cars & Motorbikes
                </a>
              </div>

              <a
                href="#"
                className="text-end text-danger fw-semibold d-block mt-3"
              >
                VIEW MORE
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Overview;
